import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ScrollingModule } from '@angular/cdk/scrolling'

import { LoginComponent } from './components/loginPage/login.component'
import { NzModule } from './nz.module'
import { PipesModule } from './pipes.module'

@NgModule({
  declarations: [
    LoginComponent,
    // Admin Hub (Manage Inventory)
    // AdminHubComponent,
    // CategoriesComponent,
    // CategorySubComponent,
    // SearchCategoryPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzModule,
    PipesModule,
    ScrollingModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule
    // AdminHubComponent
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {}
